import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import SearchablePicker, { pickerItemId, pickerItemLabel, pickerItemMeta } from './SearchablePicker';

const AutocompleteInput = ({
    input,
    meta = {},
    isLoading,
    options = [],
    dispatch,
    label,
    required,
    disabled,
    style,
    className,
    placeholder,
    emptyText,
    getOptionLabel,
    getOptionMeta,
    clearOnType,
    ...props
}) => {
    const { touched, error } = meta;
    const inputProps = input || {};
    const list = Array.isArray(options) ? options : [];
    const getLabel = getOptionLabel || ((item) => pickerItemLabel(item) || item?.name || '');
    const getMeta = getOptionMeta || ((item) => {
        const login = pickerItemMeta(item);
        if (login) return login;
        const id = pickerItemId(item);
        const labelText = getLabel(item);
        if (id && id !== labelText && !/^[a-f0-9]{24}$/i.test(id)) return id;
        return '';
    });

    return (
        <SearchablePicker
            label={label}
            required={required}
            placeholder={placeholder || (label ? `Найти: ${String(label).toLowerCase()}` : 'Найти')}
            options={list}
            value={inputProps.value}
            onChange={(item) => inputProps.onChange(item ? pickerItemId(item) : null)}
            disabled={disabled}
            loading={Boolean(isLoading && !list.length)}
            error={touched && error ? error : ''}
            style={{ minWidth: 250, ...style }}
            className={className}
            emptyText={emptyText || 'Ничего не найдено'}
            getId={pickerItemId}
            getLabel={getLabel}
            getMeta={getMeta}
            clearOnType={clearOnType}
        />
    );
};

const mapStateToProps = (state) => {
    const { fetch } = state;
    return {
        isLoading: !!fetch.loading,
    };
};

export default compose(
    connect(mapStateToProps),
)(AutocompleteInput);
